const SecurityGroupModule = () => import(/* webpackChunkName: "PlayerOverv3iewaa" */ './containers/security-group/SecurityGroupModule');
const SecurityRoleModule = () => import('./containers/security-role/SecurityRoleModule');
const AdministratorList = () => import(/* webpackChunkName: "AdministratorList" */ './containers/AdministratorList');
const AdministratorDetails = () => import(/* webpackChunkName: "AdministratorDetails" */ './containers/AdministratorDetails');
const AdministratorProfile = () => import(/* webpackChunkName: "AdministratorProfile" */ './components/profile/AdministratorProfile');
const AdministratorSecurity = () => import(/* webpackChunkName: "AdministratorSecurity" */ './components/security/AdministratorSecurity');


export const administratorsRouting = [
    {path: '/administration/groups', name: 'security-group', component: SecurityGroupModule},
    {path: '/administration/roles', name: 'security-role', component: SecurityRoleModule},
    {path: '/administration/administrator', name: 'administrator', component: AdministratorList},
    {
        path: '/administration/administrator/:id', component: AdministratorDetails,
        children: [
            {path: '/', redirect: 'profile'},
            {
                path: 'profile',
                name: 'administrator-profile',
                component: AdministratorProfile
            },
            {
                path: 'security',
                name: 'administrator-security',
                component: AdministratorSecurity
            }
        ]
    }
]
